import { render, staticRenderFns } from "./ProjectActionsShowFolders.vue?vue&type=template&id=f73990e8&scoped=true&lang=pug&"
import script from "./ProjectActionsShowFolders.vue?vue&type=script&lang=js&"
export * from "./ProjectActionsShowFolders.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActionsShowFolders.vue?vue&type=style&index=0&id=f73990e8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73990e8",
  null
  
)

export default component.exports